export default __webpack_public_path__ + "static/media/IconDesc_Explosive.256.b50e5da1.png";